import Box from "@mui/material/Box";
import { useTranslationApp } from "../../../lib/i18next";
import { ANNOTATIONS_MENTION_ALL } from "../../../i18n/keysTranslations";
import { renderAnnotationTextSegments } from "../utils/annotationMentions";

const VARIANT_TEXT_COLOR = {
  input: "text.primary",
  ownBubble: "primary.contrastText",
  otherBubble: "text.primary",
};

const MENTION_SX_BY_VARIANT = {
  input: {
    fontWeight: 400,
    // Faux-bold keeps glyph width aligned with the transparent textarea caret.
    textShadow: "0.35px 0 currentColor, -0.35px 0 currentColor",
  },
  ownBubble: { fontWeight: 700 },
  otherBubble: { fontWeight: 700 },
};

const AnnotationMentionFormattedText = ({
  text = "",
  ownersByID = {},
  variant = "input",
  textColor = null,
  component = "div",
  sx = {},
}) => {
  const { t } = useTranslationApp();
  const resolvedColor =
    textColor || VARIANT_TEXT_COLOR[variant] || "text.primary";

  const segments = renderAnnotationTextSegments({
    text,
    ownersByID,
    t,
    allLabelKey: ANNOTATIONS_MENTION_ALL,
  });

  return (
    <Box
      component={component}
      sx={{
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        color: resolvedColor,
        fontWeight: 400,
        ...sx,
      }}
    >
      {segments.map((segment, segmentIndex) =>
        segment.type === "mention" ? (
          <Box
            component="span"
            key={`mention-${segmentIndex}`}
            sx={
              MENTION_SX_BY_VARIANT[variant] ||
              MENTION_SX_BY_VARIANT.otherBubble
            }
          >
            {segment.value}
          </Box>
        ) : (
          <Box component="span" key={`text-${segmentIndex}`}>
            {segment.value}
          </Box>
        )
      )}
      {text.endsWith("\n") ? <br /> : null}
    </Box>
  );
};

export default AnnotationMentionFormattedText;
